export default {
  "nl": {
    "editor_ziggu": {
      "actions": {
        "showLess": "Toon minder",
        "showMore": "Toon meer"
      },
      "placeholders": {
        "content": "Begin met typen..",
        "link": "Typ/plak een link"
      }
    }
  }
}